export class KVP {
    constructor(key,value){
        this.key = key,
        this.value = value
    }
    key:object;
    value:object;
}